import React, {useState, useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {base, projects_url} from "../../api";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {TabView, TabPanel} from "primereact/tabview";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import walletInfo from "../../assets/images/icons/unicons/wallet-info.png";
import computer from "../../assets/images/icons/unicons/computer.png";
import chartSuccess from "../../assets/images/icons/unicons/chart-success.png";
import briefcase from "../../assets/images/icons/unicons/briefcase.png";
import ProjectDashboardInfoCard from "./Components/ProjectDashboardInfoCard";
import NewProject from "./NewProject";
import {
	projectTitle,
	projectID,
	projectDates,
	projectAction,
	projectStatus,
} from "./widgets/Widget";
import {Toast} from "primereact/toast";

export default function ProjectsDashboard() {
	const toast = useRef(null);
	const navigate = useNavigate();
	const [ongoingProjects, setOngoingProjects] = useState([]);
	const [completedProjects, setCompletedProjects] = useState([]);
	const [newProject, setNewProject] = useState(false);
	const [selectedProject, setSelectedProject] = useState(null);

	useEffect(() => {
		loadData();
	}, []);

	function loadData() {
		axios.get(base + projects_url).then(res => {
			const sortedProjects = res.data.sort((a, b) => b.id - a.id);
			setOngoingProjects(sortedProjects.filter(item => !item.completed));
			setCompletedProjects(sortedProjects.filter(item => item.completed));
		});
	}

	function handleRowClick(project) {
		if (project?.id) {
			navigate(`/project/${project.id}`);
		}
	}

	function renderDataTable(data) {
		return (
			<DataTable
				value={data}
				paginator
				rows={50}
				rowsPerPageOptions={[20, 30, 50, 100]}
				dataKey="id"
				globalFilterFields={["full_name"]}
				emptyMessage="Նախագիծ չի գտնվել"
				selectionMode="single"
				selection={selectedProject}
				onSelectionChange={e => {
					setSelectedProject(e.value);
					handleRowClick(e.value);
				}}>
				<Column body={projectStatus} className="col-1"></Column>
				<Column body={projectID} className="col-2"></Column>
				<Column body={projectTitle} className="col-6"></Column>
				<Column body={projectDates} className="col-2"></Column>
				<Column body={projectAction} className="col-1"></Column>
			</DataTable>
		);
	}

	return (
		<>
			<Toast ref={toast} />

			<Dialog
				header="Ավելացնել նոր նախագիծ"
				visible={newProject}
				onHide={() => setNewProject(false)}
				style={{width: "60vw"}}
				modal
				dismissableMask>
				{newProject && (
					<NewProject
						setNewProject={val => {
							setNewProject(val);
							if (!val)
								toast.current.show({
									severity: "info",
									summary: "Նախագիծ",
									detail: "Փոփոխությունները պահպանվեցին կամ չեղարկվեցին",
								});
						}}
						loadData={loadData}
					/>
				)}
			</Dialog>

			<div className="col-lg-12 mb-4">
				<div className="p-3">
					<div className="d-flex justify-content-end">
						<Button className="btn btn-primary px-5" onClick={() => setNewProject(true)}>
							Ավելացնել նոր նախագիծ
						</Button>
					</div>
				</div>
			</div>
			<div className="col-lg-12 mb-4">
				<div className="card w-100 b-radius b-shadow px-3 py-5">
					<TabView>
						<TabPanel header={`Ընթացիկ նախագծեր (${ongoingProjects?.length}) հատ`}>
							{renderDataTable(ongoingProjects)}
						</TabPanel>
						<TabPanel header={`Ավարտված նախագծեր (${completedProjects?.length}) հատ`}>
							{renderDataTable(completedProjects)}
						</TabPanel>
					</TabView>
				</div>
			</div>
		</>
	);
}
